import { render, staticRenderFns } from "./TotalWOBacklog.vue?vue&type=template&id=a3ca8e88&scoped=true"
import script from "./TotalWOBacklog.vue?vue&type=script&lang=js"
export * from "./TotalWOBacklog.vue?vue&type=script&lang=js"
import style0 from "./TotalWOBacklog.vue?vue&type=style&index=0&id=a3ca8e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca8e88",
  null
  
)

export default component.exports